import { OrderAdditionalDetailsClient } from "@lib/ShiOneClient";
import { useApi } from "@utils/useApi";
import { useQuery } from "@tanstack/react-query";
import { OrdersQueryKeys } from "@features/orders-features/hooks/OrdersQueryKeys";
import ms from "ms";

export function useGetOrderLineSerials(biOrderId: number | undefined) {
  const api = useApi(OrderAdditionalDetailsClient);
  const fetch = async () => {
    if (!biOrderId) return null;
    return await api.getOrderLineSerialsByBiOrderId(biOrderId);
  };
  return useQuery({
    queryKey: [OrdersQueryKeys.OrderLineSerials, biOrderId],
    queryFn: fetch,
    enabled: !!biOrderId,
    staleTime: ms("1m"),
    retry: false,
  });
}
